import { makeStyles } from "@fluentui/react-components";
import { Card, CardPreview } from "@fluentui/react-components/unstable";
import { useState } from "react";
import {
  AddAssignmentDialog,
  AssignmentsList,
  CenteredLayout,
  EngagementStatusCard,
  OvertimeStatusCard,
} from "../../../components/layouts";
import useAsignments from "../../../hooks/useAsignments";
import useMyEngagement from "../../../hooks/useMyEngagement";

const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    rowGap: "1rem",
    marginTop: "4rem",
  },
  tilesRow: {
    display: "flex",
    flexDirection: "column",
    rowGap: "1rem",
    columnGap: "1rem",
    "@media (min-width: 966px)": {
      flexDirection: "row",
      alignItems: "stretch",
    },
  },
  instructionBtn: {
    zIndex: "1",
    height: "2rem",
    marginInlineStart: "auto",
    marginInlineEnd: "1rem",
    width: "8rem",
  },
});

const now = new Date();

const ManageOvertime = () => {
  const styles = useStyles();
  const { assignments, getAssignments, isLoading, setAssignments } =    useAsignments();
  const [openDialog, setOpenDialog] = useState(false);

  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth() + 1;
  const { engagement, isLoading: isEngagementLoading } = useMyEngagement(
    currentYear,
    currentMonth
  );

  return (
    <>
      <CenteredLayout>
        <AddAssignmentDialog
          open={openDialog}
          setOpen={setOpenDialog}
          getAssignments={getAssignments}
          setAssignments={setAssignments}
        />
        <div className={styles.container}>
          <div className={styles.tilesRow}>
            {engagement.hasIncompleteWorkHours && (
              <EngagementStatusCard
                engagement={engagement}
                isLoading={isEngagementLoading}
                year={currentYear}
                month={currentMonth}
              />
            )}
            <OvertimeStatusCard />
          </div>
          <Card>
            <CardPreview>
              <AssignmentsList
                tableHeadTxt="Wnioski i zlecenia"
                items={assignments}
                getMoreUsers={getAssignments}
                isLoading={isLoading}
                setOpendialog={setOpenDialog}
              />
            </CardPreview>
          </Card>
        </div>
      </CenteredLayout>
    </>
  );
};

export default ManageOvertime;
